<div>
  <label class="form-label input-title">
    {{ inputTitle! | translate }}

    <ng-content select="label"></ng-content>

    @if (requiredFl || isRequired()) {
      <span class="required-mark font-body">
        *
      </span>
    }
  </label>

  <div
    class="input-content input-group"
    [class.has-validation]="hasValidator()"
    [ngStyle]="{ gap }"
    >
    <ng-content></ng-content>

    @if (errorText || hasValidator()) {
      <div
        class="form-text error-text invalid-feedback"
        [class.invalid]="errorText || isInvalid()"
        [class.validated]="errorText"
        >
        {{ errorText }}
        <ng-content select="[error]"></ng-content>
      </div>
    }
  </div>

  @if (noticeText) {
    <div class="form-text notice-text font-caption">
      {{ noticeText }}
    </div>
  }
</div>
